<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import AnnouncementBar from '@/components/marketing/layout/AnnouncementBar.vue';
import SiteFooter from '@/components/marketing/layout/SiteFooter.vue';
import SiteHeader from '@/components/marketing/layout/SiteHeader.vue';
import AIAgentShowcaseSection from '@/components/marketing/sections/AIAgentShowcaseSection.vue';
import AutomationControlSection from '@/components/marketing/sections/AutomationControlSection.vue';
import ContentCreationSection from '@/components/marketing/sections/ContentCreationSection.vue';
import EarlyAccessSection from '@/components/marketing/sections/EarlyAccessSection.vue';
import FAQSection from '@/components/marketing/sections/FAQSection.vue';
import FeaturesBentoSection from '@/components/marketing/sections/FeaturesBentoSection.vue';
import FinalCTASection from '@/components/marketing/sections/FinalCTASection.vue';
import HeroSection from '@/components/marketing/sections/HeroSection.vue';
import HowItWorksSection from '@/components/marketing/sections/HowItWorksSection.vue';
import IntegrationsSection from '@/components/marketing/sections/IntegrationsSection.vue';
import ProblemSolutionSection from '@/components/marketing/sections/ProblemSolutionSection.vue';
import ProductPreviewSection from '@/components/marketing/sections/ProductPreviewSection.vue';
import PublishingSection from '@/components/marketing/sections/PublishingSection.vue';
import VideoStudioSection from '@/components/marketing/sections/VideoStudioSection.vue';
import WebsiteAutomationSection from '@/components/marketing/sections/WebsiteAutomationSection.vue';
import WhoItsForSection from '@/components/marketing/sections/WhoItsForSection.vue';

const description =
    'LaunchStation is an AI marketing assistant for business owners. It learns your business, writes your content, and helps you publish across your channels from one workspace.';

defineOptions({ inheritAttrs: false });
</script>

<template>
    <div class="bg-background text-foreground flex min-h-screen flex-col">
        <Head title="Your marketing, on autopilot">
            <meta
                head-key="description"
                name="description"
                :content="description"
            />
            <meta
                head-key="og:title"
                property="og:title"
                content="LaunchStation"
            />
            <meta
                head-key="og:description"
                property="og:description"
                :content="description"
            />
            <meta head-key="og:type" property="og:type" content="website" />
        </Head>

        <AnnouncementBar />
        <SiteHeader />

        <main class="flex-1">
            <HeroSection />
            <ProductPreviewSection />
            <ProblemSolutionSection />
            <HowItWorksSection />
            <FeaturesBentoSection />
            <AIAgentShowcaseSection />
            <ContentCreationSection />
            <VideoStudioSection />
            <PublishingSection />
            <WebsiteAutomationSection />
            <AutomationControlSection />
            <IntegrationsSection />
            <WhoItsForSection />
            <EarlyAccessSection />
            <FAQSection />
            <FinalCTASection />
        </main>

        <SiteFooter />
    </div>
</template>
